import { createContext, useContext } from 'react';

const ScrollContainerContext = createContext<HTMLDivElement | null>(null);

export function useScrollContainer() {
  return useContext(ScrollContainerContext);
}

export { ScrollContainerContext };
